import { SystemStyleObject } from '@chakra-ui/react';

import { typographyVariants } from '@/theme/components/typography-variants';
import { DOMElements } from '@/utils/models/parse-html-to-react';

export const inventoryDefinitionStyles: SystemStyleObject = {
  '&': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [DOMElements.H1]: {
    base: {
      ...typographyVariants['component-heading-large/xl'],
      mt: 4,
      color: 'purple.500',
    },
    sm: {
      ...typographyVariants['component-heading-large/3xl'],
      mt: 8,
      textAlign: 'center',
    },
    lg: {
      ...typographyVariants['component-heading-large/4xl'],
      mt: 3,
    },
  },
  [DOMElements.P]: {
    base: {
      ...typographyVariants['text-md/lineHeight-6/font-normal'],
      mt: 8,
      color: 'purple.400',
    },
    sm: {
      ...typographyVariants['text-xl/lineHeight-7/font-normal'],
      mt: 10,
    },
    lg: {
      ...typographyVariants['text-md/lineHeight-6/font-normal'],
    },
  },
  [DOMElements.H2]: {
    base: {
      ...typographyVariants['component-paragraph-headline/2xl'],
      mt: 32,
      color: 'purple.500',
      alignSelf: 'flex-start',
    },
    sm: {
      ...typographyVariants['component-paragraph-headline/3xl'],
      mt: 20,
      pl: 24,
    },
    xl: {
      mt: 16,
      pl: 0,
    },
  },
  [DOMElements.A]: {
    base: {
      ...typographyVariants['text-md/lineHeight-6/font-semibold'],
      color: 'violet.500',
    },
  },
  'figure.image': {
    base: {
      transform: 'rotate(-16deg)',
    },
  },
  figure: {
    maxW: '100%',
    '& figure': {
      margin: 0,
    },
  },
  blockquote: {
    '& figure': {
      margin: 0,
    },
  },
  'h2 ~ p': {
    base: {
      mt: 4,
      alignSelf: 'flex-start',
    },
    sm: {
      mt: 5,
      pl: 24,
    },
    xl: {
      pl: 0,
    },
  },
};
